import { CSS } from ".."
import { SearchIcon } from "../../Icons"

const legacyStyle = (): CSS => ({
  marginRight: `10px`,
  flexShrink: 0,
})

export const SearchIconLegacy = () => <SearchIcon css={legacyStyle} variant="legacy" />
